// © Microsoft Corporation. All rights reserved.

import {
    DesignSystem
} from "@microsoft/fast-components-styles-msft";
import { applyLocalizedProperty } from "@microsoft/fast-jss-utilities";
import { enums } from "../../../../../utils/enums";

export const ProfileCardUserStatsSuperAppStyles = (config: DesignSystem) => ({
    profileCardUserStatsSuperAppContainer: {
        "justify-content": "center",
        margin: "8px 0 0",
        "& .cwt-stat": {
            color: "white",
            "flex-direction": "row",
            [applyLocalizedProperty("margin-right", "margin-left", config.direction)]: "22px",
            "align-items": "flex-end",

            "&:last-child": {
                [applyLocalizedProperty(
                    "margin-right",
                    "margin-left",
                    config.direction
                )]: "0"
            },

            "& .cwt-icon": {
                color: "white",
                opacity: "0.6"
            },

            "& .cwt-stat-counter": {
                "margin-top": "0",
                "font-size": "15px",
                [applyLocalizedProperty("margin-left", "margin-right", config.direction)]: "9px",
                "line-height": "20px",
                "font-weight": "500"
            }

        },
        "&.cwt-stats-others": {
            "& .cwt-stat": {
                [applyLocalizedProperty("margin-right", "margin-left", config.direction)]: "25px",

                "& .cwt-icon": {
                    "font-size": "16px"
                },
                "& .cwt-stat-counter": {
                    "font-size": "15px",
                    "line-height": "20px"
                }
            }
        },

        ["&." + enums.responsiveLevels.L0]: {
            "& .cwt-stat": {
                [applyLocalizedProperty("margin-right", "margin-left", config.direction)]: "22px"
            },
            "&.cwt-stats-others": {
                "& .cwt-stat": {
                    [applyLocalizedProperty("margin-right", "margin-left", config.direction)]: "22px",

                    "& .cwt-icon": {
                        "font-size": "13px"
                    },
                    "& .cwt-stat-counter": {
                        "font-size": "12px",
                        "line-height": "16px"
                    }
                }
            }
        }
    }
});
